/**
 * @file
 * In-page navigation functionality.
 */

(($, { behaviors }, _, options, breakpoint) => {
  /**
   * Smooth page scroll to clicked link's corresponding section.
   *
   * @param {Element} element
   *   An element to scroll to.
   */
  function inPageSmoothScroll(element) {
    const scrollSpeed = 500;
    const $window = $("html, body");
    const offset = window.matchMedia(breakpoint.large).matches
      ? options.titleHighlightOffsetLarge
      : options.titleHighlightOffsetSmall;

    $window.animate(
      {
        scrollTop:
          $($.attr(element, "href")).offset().top +
          $(element).outerHeight() -
          offset
      },
      scrollSpeed
    );
  }

  /**
   * Attaches behaviors for in-page navigation.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Attaches in-page navigation functionality.
   */
  behaviors.inPageNavigation = {
    attach(context) {
      const $inPageNavLink = $(".in-page-nav .in-page-nav__link", context);

      $inPageNavLink.click((event) => {
        inPageSmoothScroll(event.currentTarget);
      });
    }
  };
})(jQuery, Drupal, _, window.inPageNavOptions, window.breakpoints);
